import { useEffect, useState } from 'react';
// import customAxios from 'path-to-your-axios'; // Update this path
// import { authHeader } from 'path-to-authHeader'; // Update this path

import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useGetSpeciesDropdown = () => {
  const [species, setSpecies] = useState([]);

  useEffect(() => {
    const fetchSpecies = async () => {
      try {
        const res = await customAxios.post('/GenTasks/GetDropdownListArray', ['Species'], {
          headers: authHeader(),
        });
        if (res.status === 200 && Array.isArray(res.data)) {
          const speciesData = res.data.find(item => item.keyName?.toLowerCase() === 'species');
          setSpecies(speciesData?.values || []);
        }
      } catch (err) {
        console.error('Failed to fetch species:', err);
      }
    };

    fetchSpecies();
  }, []);

  return species;
};

export default useGetSpeciesDropdown;
